<section class="centered">
	<div class="col-medium">
		<slot></slot>
	</div>
</section>